import { FloatingFormItem } from '@/components/_common';
import useCommonGenerateReport from '@/core/domain/reports/commons/Report.hook';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { Col, Form, Modal, ModalProps, Radio, Row, Typography } from 'antd';
import React from 'react';

export enum ReportFormatEnum {
  formatA4 = 'FORMAT_A4',
  format58mm = 'FORMAT_58_MM',
}

interface Props extends ModalProps {
  directSaleId?: number;
  onCancel: VoidFunction;
}

const DirectSalePrintModal = ({ directSaleId, onCancel, ...props }: Props) => {
  const ReportFormatOptions = [
    {
      value: ReportFormatEnum.formatA4,
      label: 'Padrao A4',
    },
    {
      value: ReportFormatEnum.format58mm,
      label: '58mm',
    },
  ];

  const report = useReportGenerate();
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const [form] = Form.useForm<{ reportFormat: ReportFormatEnum }>();

  const reportFormat = Form.useWatch('reportFormat', form);

  const generateReport = useCommonGenerateReport<{ directSaleId: number }>(
    '/generate/direct-sale',
    'Relatório gerado com sucesso!',
    'Relatório de venda direta gerado com sucesso.',
  );

  const handlePrintReport = async (
    saleId: number,
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const obj = {
        directSaleId: saleId,
        reportFormat,
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const handleView = async (saleId: number) => {
    await handlePrintReport(saleId, 'REPORT_VIEW', (result) => {
      try {
        report.openFile({
          result,
          fileName: 'relatório_venda_direta_administrativo.pdf',
          fileType: 'application/pdf',
        });
      } catch (error) {
        console.error('Erro ao abrir o arquivo:', error);
      }
    });
  };

  const handleOk = async () => {
    if (directSaleId) {
      await handleView(directSaleId);
    }
    onCancel();
  };

  return (
    <Modal
      title="Imprimir Venda"
      {...props}
      confirmLoading={fileLoading.REPORT_VIEW}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Imprimir"
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Typography.Title level={5}>
              {'Formato do relatório'}
            </Typography.Title>
            <FloatingFormItem
              name="reportFormat"
              initialValue={ReportFormatEnum.formatA4}
            >
              <Radio.Group
                buttonStyle="solid"
                optionType="button"
                size="large"
                options={ReportFormatOptions}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DirectSalePrintModal;
